// extracted by mini-css-extract-plugin
export default {"tableContainer":"styles_tableContainer__X5+QU","normalRow":"styles_normalRow__ItdYC","almostPaidRow":"styles_almostPaidRow__1WbA5"};